<template>
    <span ref="input" class="ah-invoice-number-checker">
        <div class="duplicate-hint">
            <i v-if="isCheckingInvoice" class="el-icon-loading" />
            <template v-else-if="isChecked">
                <el-alert v-if="numberUsedList" type="warning" size="small" :closable="false" class="small-alert"> 此號碼已存在，發票單號：{{ numberUsedList }} </el-alert>
            </template>
        </div>
    </span>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';

export default {
    name: 'ah-invoice-number-checker',
    props: {
        checkNumber: {
            type: String,
            default: null,
        },
        checkDate: {
            type: Number,
            default: null,
        },
        ioo: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            isPaste: false,
            isCheckingInvoice: false,
            numberUsedList: false,
            isChecked: false,
        };
    },
    mounted() {
        this.onCheckValidateInvoice();
    },
    computed: {
        inputVal: {
            get() {
                return this.checkNumber;
            },
            set(val) {
                if (val?.length < 10) this.isChecked = false;
            },
        },
    },
    methods: {
        async onCheckValidateInvoice() {
            if (!this.checkNumber || this.checkNumber.length < 10 || !this.checkDate) return;
            try {
                this.isCheckingInvoice = true;
                const resp = await this.$api({
                    url: '/InvoiceManagemnetPage/QueryAuidingInvoice',
                    params: {
                        foo: this.checkNumber,
                        year: moment(this.checkDate).year(),
                    },
                    method: 'GET',
                });
                this.numberUsedList = _.chain(resp.data.items)
                    .filter((o) => (o.tranInvoice ? o.tioo !== this.ioo : o.ioo !== this.ioo))
                    .map((o) => (o.tranInvoice ? "(核銷轉開)"+o.tioo : o.ioo))
                    .value()
                    .join('、');
            } finally {
                this.isCheckingInvoice = false;
                this.isChecked = true;
            }
        },
    },
};
</script>
<style lang="scss">
.ah-invoice-number-checker {
    .duplicate-hint {
        display: inline-block;
        // line-height: 10px;
        vertical-align: top;
        .small-alert {
            padding: 10px;
            p {
                margin-top: 0;
            }
        }
    }
}
</style>
